import React, {
  forwardRef,
  useEffect,
  useImperativeHandle,
  useState,
} from "react";
import { useRecoilValue } from "recoil";
import { wsReadyState } from "../global-state";
import { useWebSocket } from "../ws/websocket";

export const ScriptSpecData = forwardRef((props, ref) => {
  // key is block name
  const [blocks, setBlocks] = useState(new Map());
  // store the latest detailed input spec for the blockName, key is block name.
  // {blockName: {input: [], content: ''}}
  const [fields, setFields] = useState(new Map());
  const [integrationTypes, setIntegrationTypes] = useState([]);

  const wsReady = useRecoilValue(wsReadyState);
  const { sendAndWaitWs } = useWebSocket();

  useEffect(() => {
    if (wsReady) {
      loadBaseSpec();
    }
  }, [wsReady]);

  const loadBaseSpec = async () => {
    const payload = {
      type: "base",
    };
    const resp = await callWs(payload);
    if (resp.blocks) {
      for (const blockName in resp.blocks) {
        blocks.set(blockName, resp.blocks[blockName]);
      }
    }
    if (resp.integrationTypes) {
      setIntegrationTypes(resp.integrationTypes);
    }
  };

  const loadBlockSpec = async (name) => {
    console.debug(name);
    const payload = {
      type: "block",
      name,
    };
    const resp = await callWs(payload);
    console.debug(resp);
    if (resp.blocks) {
      for (const blockName in resp.blocks) {
        blocks.set(blockName, resp.blocks[blockName]);
      }
    }
  };

  const loadFieldSpec = async (name, fieldJson) => {
    console.debug(name);
    console.debug(fieldJson);

    const payload = {
      type: "field",
      name,
      fieldJson,
    };
    const resp = await callWs(payload);
    console.debug(resp);
    if (resp.fields) {
      fields.set(name, { fields: resp.fields, sig: fieldJson });
    }
  };

  const callWs = async (payload) => {
    return {};
  };

  const getIntegrationTypes = () => {
    return integrationTypes;
  };

  const getSpec = async (name) => {
    if (blocks.size === 0) {
      await loadBaseSpec();
      if (blocks.size === 0) {
        return null;
      }
    }
    if (blocks.has(name)) {
      return blocks.get(name);
    } else {
      await loadBlockSpec(name);
      return blocks.get(name);
    }
  };

  const getFieldSpec = async (name, integration, content) => {
    console.debug(111);
    console.debug(content);
    if (!name || !content || !integration) {
      return {};
    }
    const fieldData = content.reduce((acc, { key, value, values }) => {
      if (values && values.length > 0) {
        acc[key] = values;
      } else {
        acc[key] = value;
      }
      return acc;
    }, {});
    const fieldJson = JSON.stringify(fieldData);
    if (fields.has(name)) {
      if (fields.get(name).sig === fieldJson) {
        return fields.get(name).fields;
      }
    }
    console.debug(fieldJson);
    console.debug(name);
    await loadFieldSpec(name, fieldJson);
    return fields.get(name).fields;
  };

  useImperativeHandle(ref, () => ({
    getSpec,
    getIntegrationTypes,
    getFieldSpec,
  }));

  return <div></div>;
});

ScriptSpecData.displayName = "ScriptSpecData";
